import { useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";

// NOTE: Placeholder quotes until real teacher interviews are done. Flag with product
// team before launch (per handoff README).
const TESTIMONIALS = [
  { key: "t1", color: "#8B5CF6" },
  { key: "t2", color: "#F97316" },
  { key: "t3", color: "#22C55E" },
];

function TestimonialsSection() {
  const { t } = useTranslation("marketing");

  return (
    <section className="ul-section ul-testi-section" id="testimonials">
      <div className="ul-center" style={{ marginBottom: 48 }}>
        <SectionLabel>{t("testimonials.label")}</SectionLabel>
        <h2 className="ul-section-title">{t("testimonials.title")}</h2>
      </div>
      <div className="ul-testi-grid">
        {TESTIMONIALS.map((item) => (
          <div className="ul-testi-card" key={item.key}>
            <div className="ul-testi-author">
              <div className="ul-author-avatar" style={{ background: item.color }}>{t(`testimonials.items.${item.key}.initial`)}</div>
              <div>
                <div className="ul-author-name">{t(`testimonials.items.${item.key}.name`)}</div>
                <div className="ul-author-role">{t(`testimonials.items.${item.key}.role`)}</div>
              </div>
            </div>
            <div className="ul-stars" aria-label={t("testimonials.starsAria")}>★★★★★</div>
            <div className="ul-testi-text">"{t(`testimonials.items.${item.key}.quote`)}"</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TestimonialsSection;
